/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data-ids used on the static sites screen.
 */
export const STATIC_SITES_DATA_IDS = {
  actionAddRoute: `Button: Add static site route`,
  actionAddRouteCancel: `Add static site route: Cancel action`,
  actionAddRouteConfirm: `Add static site route: Confirm action`,
  actionDeleteRoute: `Button: Delete static site route`,
  actionDeleteRouteCancel: `Delete static site route: Cancel action`,
  actionDeleteRouteConfirm: `Delete static site route: Confirm action`,
  actionEditRoute: `Button: Edit static site route`,
  actionEditRouteCancel: `Edit static site route: Cancel action`,
  actionEditRouteConfirm: `Edit static site route: Confirm action`,
  addToastSuccess: `Toast: Route created`,
  deleteToastFailure: `Toast: Route deletion failed`,
  deleteToastSuccess: `Toast: Route deleted`,
  editToastSuccess: `Toast: Route updated`,
  manageRoutesEmptyState: `Static site route list: No routes`,
  pathUrl: `Form field: Path URL`,
  repositoryPath: `Form field: Repository path`,
  staticSitesListButton: `Static sites list button: Navigate to routes`,
  staticSitesListEmptyState: `Static sites list: No sites`,
  staticSiteUrl: `Form field: Static site URL`,
};

/**
 * The form field ids used on the static sites screen.
 */
export const STATIC_SITES_FORM_IDS = {
  pathUrl: `path-url`,
  staticSiteUrl: `static-site-url`,
};
